var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vd-page-container d-flex justify-center",class:_vm.spacingClass},[_c('VSheet',{attrs:{"width":_vm.containerSize,"color":_vm.color}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }